import { render, staticRenderFns } from "./configStatusColors.vue?vue&type=template&id=640307ba&scoped=true"
import script from "./configStatusColors.vue?vue&type=script&lang=js"
export * from "./configStatusColors.vue?vue&type=script&lang=js"
import style0 from "./configStatusColors.vue?vue&type=style&index=0&id=640307ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640307ba",
  null
  
)

export default component.exports